<mat-card class="m-4">
  <mat-card-header>
    <mat-card-title>Define {{apiType == 'api'? 'API' : 'Authentication'}} Call</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="d-flex mt-4 align-items-center">
      <mat-button-toggle-group [(ngModel)]="stage" (change)="stageSetter($event)"  aria-label="stage">
        <mat-button-toggle value="define">Call Definition</mat-button-toggle>
        <mat-button-toggle value="test" [disabled]="apiType === 'api'? apiForm.invalid : AuthApiGroup.invalid" >Test API</mat-button-toggle>
      </mat-button-toggle-group>
      <div class="flex-fill"></div>
      <div *ngIf="stage == 'test'"> <button mat-raised-button class="primary" (click)="testAPICall()"> Test API</button>
      </div>
    </div>
    <div class="mt-3" *ngIf="stage == 'define'">
      <ng-container *ngIf="apiType == 'api'">
        <form [formGroup]="apiForm" (ngSubmit)="submit(false)">

          <div class="row g-3">
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" [minLength]="5"  placeholder="Enter Url Name">
                <mat-error *ngIf="apiForm.get('name')?.hasError('required')">Name is required</mat-error>
                <mat-error *ngIf="apiForm.get('name')?.hasError('minlength')">Length should be alteast 5</mat-error>
                <mat-error *ngIf="apiForm.get('name')?.hasError('maxlength')">Length should not be greater than 45</mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Method</mat-label>
                <mat-select formControlName="method">
                  <mat-option value="GET">GET</mat-option>
                  <mat-option value="POST">POST</mat-option>
                  <mat-option value="PUT">PUT</mat-option>
                  <mat-option value="PATCH">PATCH</mat-option>
                  <mat-option value="DELETE">DELETE</mat-option>
                </mat-select>
                <mat-error *ngIf="apiForm.get('method')?.invalid && apiForm.get('method')?.touched">Method is
                  required</mat-error>
              </mat-form-field>
            </div>
            <div class="col-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>URL</mat-label>
                <input matInput formControlName="url" placeholder="Enter URL">
                <mat-error *ngIf="apiForm.get('url')?.hasError('required')">URL is required</mat-error>
                <mat-error *ngIf="apiForm.get('url')?.hasError('pattern')">Enter a valid URL</mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-tab-group class="mt-4">
            <mat-tab label="Headers" class="mt-3">
              <lib-form-array-template [formArrayName]="'apiheaders'" [arrayformGroup]="apiForm" [label]="'Headers'"
                [arraySubGroup]="headerkeyValueGroup"  [tabType]="apiTabTypes.headers" [currentFormValue]="apiForm.value"></lib-form-array-template>
            </mat-tab>
            <mat-tab label="Body" *ngIf="['POST','PUT','PATCH'].includes(apiForm.get('method')?.value)" class="mt-3">
              <ngx-monaco-editor class="textEditorContainer" [options]="editorOptions" formControlName="body"  (init)="editorInit($event)"></ngx-monaco-editor>
            </mat-tab>
            <mat-tab label="Query Parameters" *ngIf="['GET','DELETE'].includes(apiForm.get('method')?.value)"
              class="mt-3">
              <lib-form-array-template [formArrayName]="'queryParameters'" [arrayformGroup]="apiForm"
                [label]="'Query Parameters'" [arraySubGroup]="paramkeyValueGroup"
                [tabType]="apiTabTypes.queryParems" [currentFormValue]="apiForm.value"></lib-form-array-template>
            </mat-tab>
            <mat-tab label="Variables" class="mt-3">
              <lib-form-array-template [formArrayName]="'variables'" [arrayformGroup]="apiForm" [label]="'Variables'"
                [arraySubGroup]="paramkeyValueGroup" [tabType]="apiTabTypes.variables" [currentFormValue]="apiForm.value"></lib-form-array-template>
            </mat-tab>
            <mat-tab label="Authentication" class="mt-3">
              <div>
                <mat-form-field appearance="outline" class="w-100 mt-2">
                  <mat-label>Auth API</mat-label>
                  <mat-select formControlName="authentication">
                    <mat-option [value]="authAPI.apiId"
                      *ngFor="let authAPI of authApis">{{authAPI.apiName}}</mat-option>
                  </mat-select>
                  <mat-icon matIconSuffix *ngIf="apiForm.get('authentication')?.value" (click)="apiForm.get('authentication')?.reset()">close</mat-icon>
                </mat-form-field>
              </div>
            </mat-tab>
          </mat-tab-group>
          <div class="d-flex gap-3 justify-content-end mt-4">
            @if([appPermissions.deleteApi,permissionsActions.edit] | builderPermissions) {
              <button mat-raised-button color="warn" type="button" *ngIf="editApi"  (click)="deleteAPI()">Delete</button>
            }
            <button mat-raised-button color="" type="button" *ngIf="!editApi" (click)="apiForm.reset()">Cancel</button>
            @if([appPermissions.editApi,permissionsActions.edit] | builderPermissions) {
              <button mat-raised-button color="primary" type="submit" [disabled]="apiForm.invalid" >{{editApi ? 'Update' : 'Save'}}</button>
            }
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="apiType == 'authApi'">
        <form [formGroup]="AuthApiGroup" class="mt-2" (ngSubmit)="submit(true)">

          <div class="row g-3">
            <div class="col-12">
              <mat-form-field class="w-100 rounded-0" appearance="outline">
                <mat-label>Auth API Name</mat-label>
                <input matInput formControlName="name" [maxlength]="45" [minlength]="5" />
                <mat-error *ngIf="AuthApiGroup.get('name')?.hasError('required')">Name is required</mat-error>
                <mat-error *ngIf="AuthApiGroup.get('name')?.hasError('minlength')">Length should be alteast 5</mat-error>
                <mat-error *ngIf="AuthApiGroup.get('name')?.hasError('maxlength')">Length should not be greater than 45</mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field class="w-100 mt-1 rounded-0" appearance="outline">
                <mat-label>Auth Type</mat-label>
                <mat-select formControlName="authType">
                  <mat-option value="Bearer" >Bearer</mat-option>
                </mat-select>
                <mat-error *ngIf="AuthApiGroup.get('authType')?.hasError('required')">Auth type is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col-8">
              <mat-form-field class="w-100 rounded-0" appearance="outline">
                <mat-label>Auth API URL</mat-label>
                <input matInput formControlName="url" />
                <mat-error *ngIf="AuthApiGroup.get('url')?.hasError('required')">Auth  is required</mat-error>
                <mat-error *ngIf="AuthApiGroup.get('url')?.hasError('pattern')">Enter a valid Auth URL</mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-tab-group>
            <mat-tab label="Headers" class="mt-3">
              <lib-form-array-template [formArrayName]="'headers'" [arrayformGroup]="AuthApiGroup" [label]="'Headers'"
                [arraySubGroup]="headerkeyValueGroup"  [tabType]="apiTabTypes.headers"></lib-form-array-template>
            </mat-tab>
            <mat-tab label="Body" class="mt-3">
              <ngx-monaco-editor class="textEditorContainer" [options]="editorOptions" formControlName="body"  (init)="editorInit($event)"></ngx-monaco-editor>
            </mat-tab>
          </mat-tab-group>

          <div class="d-flex gap-3 justify-content-end mt-4">
            <button mat-raised-button color="warn" type="button" *ngIf="editApi"
              (click)="deleteAPI()">Delete</button>
            <button mat-raised-button  type="button" *ngIf="!editApi"
              (click)="AuthApiGroup.setErrors(null);AuthApiGroup.reset()">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="AuthApiGroup.invalid" type="submit">{{editApi ? 'Update' : 'Save'}}</button>
          </div>

        </form>
      </ng-container>
    </div>
    <div class="mt-3" *ngIf="stage == 'test'">
      <div class="row">
        <div class="col-md-6">
          <mat-tab-group>
            <mat-tab label="Headers">
              <div class="json-container h-100 overflow-scroll">
                <pre>{{ selectedApi?.headers | json }}</pre>
              </div>
            </mat-tab>
            <mat-tab label="Body" *ngIf="['POST','PUT','PATCH'].includes(apiForm.get('method')?.value)">
              <div class="json-container" >
                <pre>{{ selectedApi?.requestBody }}</pre>

              </div>
            </mat-tab>
            <mat-tab label="Query Parameters"
              *ngIf="['GET','DELETE'].includes(apiForm.get('method')?.value) && apiType == 'api'">
              <div class="json-container overflow-scroll">
                <pre>{{ selectedApi?.queryParams | json }}</pre>
              </div>
            </mat-tab>
            <mat-tab label="Variables">
              <div class="json-container">
                <form [formGroup]="varablesTest" >
                  <mat-selection-list formArrayName="variableValues">
                    <mat-list-option *ngFor="let variable of variableValues.controls; let i=index" [formGroupName]="i" (selectedChange)="variableChecked($event,i)">
                      {{ variable.value.key }}
                      <mat-form-field>
                        <mat-label>Enter Value To Check</mat-label>
                        <input type="text" matInput formControlName="value" (input)="onChange($event, i)">
                      </mat-form-field>
                    </mat-list-option>
                  </mat-selection-list>
                </form>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="col-md-6">
          <mat-tab-group>
            <mat-tab label="Api URL">
              <div class="json-container overflow-scroll mt-2 ps-2">
                <pre>
                {{ updatedUrl ? updatedUrl : selectedApi?.apiURL }}
                </pre>
              </div>
            </mat-tab>
            <mat-tab label="Response" class="overflow-y-scroll">
              <div class="json-container overflow-scroll mt-2">
                <pre> {{ apiResponce |json }}</pre>

              </div>
            </mat-tab>
          </mat-tab-group>


        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>